import React, {Dispatch, SetStateAction, useCallback, useContext, useEffect, useState} from 'react';

import {Search, SearchInterface, Suggestion} from '@veneer/core';

import {MinimalSupportUser} from '@br/idm-api';

import {GlobalTranslationsContext} from '../../i18n';

const SupportUserFilter = <K extends string, F extends Partial<Record<K, string>>>({
    label,
    field,
    filters,
    setFilters,
    getSupportUsers,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
    getSupportUsers: () => Promise<Array<MinimalSupportUser>>;
}): JSX.Element => {
    const {veneer: v} = useContext(GlobalTranslationsContext);

    const [email, setEmail] = useState<string>(filters[field] || '');
    const [loading, setLoading] = useState<boolean>(true);
    const [supportUserSuggestions, setSupportUserSuggestions] = useState<Suggestion[]>([]);

    useEffect(() => {
        void getSupportUsers().then(supportUsers => {
            setSupportUserSuggestions(
                supportUsers.map(supportUser => ({
                    // We don't use ID for value since multiple support user objects can have the same email
                    value: supportUser.email,
                    label: supportUser.email,
                }))
            );
            setLoading(false);
        });
    }, [getSupportUsers]);

    const handleChange = useCallback<Required<SearchInterface>['onChange']>(
        value => {
            setFilters(filters => ({...filters, [field]: value || undefined}));
            setEmail(value || '');
        },
        [field, setFilters]
    );

    return (
        <Search
            label={label}
            id="support-user-filter"
            value={email}
            onChange={handleChange}
            suggestions={supportUserSuggestions}
            i18n={v.search}
            disabled={loading}
        />
    );
};

export default SupportUserFilter;
